import { Steps } from "./types";

export const sharedSteps: Steps = {
  q0: {
    id: "q0",
    slug: "hur-kan-vi-hjälpa-dig",
    allowDirectAccess: true,
    text: "Hur kan vi hjälpa dig?",
    type: "multipleChoice",
    options: [
      { text: "Viktnedgång", value: 1 },
      { text: "Högt blodtryck", value: 2 },
      { text: "Viktnedgång och högt blodtryck", value: 3 },
    ],
    fullWidthOptions: true,
    nextStep: (answers) => {
      if (answers?.q0 === 1) {
        return "q5";
      }
      if (answers?.q0 === 2) {
        return "q1";
      }
      return "q19";
    },
  },
};
